export default __webpack_public_path__ + "static/media/student.2cc942db.jpg";